import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';

@Component({
  selector: 'app-help-fab-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule
  ],
  templateUrl: './help-fab-button.html',
  styleUrl: './help-fab-button.scss'
})
export class HelpFabButtonComponent {
  constructor(private dialog: MatDialog) {}

  openHelp() {
    this.dialog.open(HelpDialogComponent, {
      width: '90vw',
      maxWidth: '800px',
      maxHeight: '85vh',
      disableClose: false,
      autoFocus: false,
      panelClass: 'help-dialog-panel'
    });
  }
}
